import axios from 'axios'

/** 内部券类型 → 用户可见名称 */
export const COUPON_TYPE_LABELS = {
  normal: '双享礼券',
  partner: '臻享礼券',
  cash: '专享礼券'
}

/** 列表筛选（臻享礼券在上方独立展示，不在此列表重复） */
export const LIST_COUPON_TYPE_LABELS = {
  normal: '双享礼券',
  cash: '专享礼券'
}

/** 券类型简要说明 */
export const COUPON_TYPE_HINTS = {
  normal: '系统生成 RC 券号，创建后不可修改；绑定后双方获礼遇，每张仅用一次',
  partner: '每人一个，可自定义券号；被使用后不可修改',
  cash: '管理员发放，创建后不可修改；每张仅用一次'
}

/** 双享礼券创建说明 */
export const NORMAL_COUPON_CREATE_HINT =
  '填写名称后创建，系统自动生成 RC 券号。创建后不可修改，被绑定后即失效。'

/** 臻享礼券规则说明 */
export const PARTNER_COUPON_HINT =
  '臻享资格由管理员开通。每位臻享伙伴仅有一个臻享礼券，可自定义券号（4～20 位，字母开头，不能以 RC 开头）。被使用后不可修改。'

export function couponTypeLabel(type) {
  return COUPON_TYPE_LABELS[type] || type || '—'
}

export function couponTypeHint(type) {
  return COUPON_TYPE_HINTS[type] || ''
}

export async function checkReferralCoupon(couponNo) {
  const no = (couponNo || '').trim()
  if (!no) return { valid: false, message: '' }
  const res = await axios.get('/api/v1/referral/coupon/check', { params: { couponNo: no } })
  return res.data?.data || { valid: false, message: res.data?.message || '礼券无效' }
}

export async function bindReferralCoupon(couponNo) {
  const no = (couponNo || '').trim()
  if (!no) throw new Error('请输入礼券号')
  const res = await axios.post('/api/v1/referral/bind', { couponNo: no })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '绑定失败')
  }
  return res.data
}

export async function fetchReferralBindStatus() {
  const res = await axios.get('/api/v1/referral/bind/status')
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '加载失败')
  }
  return res.data.data || {}
}

let cachedReferralSettings = null

export async function fetchReferralSettings(force = false) {
  if (!force && cachedReferralSettings) {
    return cachedReferralSettings
  }
  const res = await axios.get('/api/v1/referral/settings')
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '加载配置失败')
  }
  cachedReferralSettings = res.data.data || {}
  return cachedReferralSettings
}

export async function fetchMyReferralBindings(page = 1, pageSize = 20, couponType = '') {
  const res = await axios.post('/api/v1/referral/bindings/my-list', {
    page,
    pageSize,
    couponType: couponType || undefined
  })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '加载失败')
  }
  return res.data.data || { bindings: [], total: 0 }
}

export async function fetchMyPartnerCommission(page = 1, pageSize = 20, status = '') {
  const res = await axios.post('/api/v1/referral/commission/my-list', {
    page,
    pageSize,
    status: status || undefined
  })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '加载失败')
  }
  return res.data.data || { items: [], total: 0 }
}

export async function fetchPartnerReferralCoupon() {
  const res = await axios.get('/api/v1/referral/coupon/partner/mine')
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '加载失败')
  }
  return res.data.data || null
}

export async function savePartnerReferralCoupon({ couponNo, displayName }) {
  const res = await axios.post('/api/v1/referral/coupon/partner/set', { couponNo, displayName })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '保存失败')
  }
  return res.data.data
}

export function buildCouponBindUrl(couponNo) {
  const no = (couponNo || '').trim()
  if (!no) return ''
  return `${window.location.origin}/referral/bind-coupon?coupon=${encodeURIComponent(no)}`
}

export function buildRegisterWithCouponUrl(couponNo) {
  const no = (couponNo || '').trim()
  if (!no) return ''
  return `${window.location.origin}/register?coupon=${encodeURIComponent(no)}`
}

export function commissionStatusLabel(status) {
  const map = { settled: '已到账', pending: '待到账', cancelled: '已取消' }
  return map[status] || status || '—'
}

export function centsToYuan(cents) {
  return (Number(cents || 0) / 100).toFixed(2)
}

export async function fetchAdminReferralUserOverview({ userId, username } = {}) {
  const res = await axios.post('/api/v1/admin/referral/user/overview', {
    userId: userId || undefined,
    username: username || undefined
  })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '查询失败')
  }
  return res.data.data
}

export async function fetchAdminReferralActions(page = 1, pageSize = 20, action = '') {
  const res = await axios.post('/api/v1/admin/referral/actions/list', {
    page,
    pageSize,
    action: action || undefined
  })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '加载失败')
  }
  return res.data.data || { items: [], total: 0 }
}

export async function adminRetryReferralBonus(bindingId) {
  const res = await axios.post('/api/v1/admin/referral/bindings/retry-bonus', { bindingId })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '补发失败')
  }
  return res.data
}
